export const BASE_URL = 'https://xn-----7kcgjhvr1aieqi2a.xn--p1ai/api/v1';

export const BASE_URL_IMG = 'https://xn-----7kcgjhvr1aieqi2a.xn--p1ai';
